import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue';
import { tradeOptionsReportTableFields } from 'ah-trades/src/models/tradeTableFields';
import TradeListing from 'ah-trades/src/components/lists/TradeListing.vue';
import TradeOptionsRowDetails from 'ah-trades/src/components/lists/TradeOptionsRowDetails.vue';
import { ExportListType, PaginatedParams } from 'ah-api-gateways';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllOptionsTradesView',
  setup(__props) {

const tradeListing = ref<InstanceType<typeof TradeListing> | null>(null);

const config = computed(() => {
  return {
    tableFields: tradeOptionsReportTableFields,
  };
});

const state = reactive<{
  sortAndPageParams: Partial<PaginatedParams>;
  dataDownloadState: string;
}>({
  sortAndPageParams: { sort: 'createdAt', sortDirection: 'DESC' },
  dataDownloadState: 'idle',
});

function downloadList(format: ExportListType) {
  tradeListing.value!.downloadData(format);
}

return { __sfc: true,tradeListing, config, state, downloadList, TradeListing, TradeOptionsRowDetails, ListDownloadButton }
}

})